import IconLocationSvg from '@listening/assets/astro/icons/icon-locations.svg';
import IconContactImage from '@listening/assets/astro/images/contact-us-2.jpg';

export function FindUsSection() {
  return (
    <section className='flex flex-col items-center justify-center px-5 py-2 sm:px-14 lg:px-18'>
      <div className='flex w-full max-w-[1296px] flex-col items-center gap-18'>
        <div className='flex w-full flex-col items-center justify-center'>
          <div className='inline-flex w-full shrink grow basis-0 flex-col items-center justify-center gap-[72px] pb-4 sm:pb-[56px]'>
            <h2 className='w-full text-center text-[1.5rem] leading-[48px] font-semibold sm:text-[2rem]'>
              Contact <span className='text-azure-455'>Us</span>
            </h2>
          </div>
          <div className='relative flex size-full max-h-[600px] min-h-[250px] items-center justify-end overflow-hidden rounded-2xl sm:min-h-[400px] md:min-h-[600px]'>
            <img
              alt='Background'
              className='absolute inset-0 size-full object-cover object-bottom'
              src={IconContactImage}
            />
            <div className='absolute m-8 flex items-center justify-center self-stretch rounded-[100px] bg-white/40 p-1.5'>
              <div className='flex items-center justify-center rounded-[100px] bg-white/75 p-3'>
                <img
                  alt='icon locations'
                  className='size-6'
                  loading='lazy'
                  src={IconLocationSvg}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
